// @flow
import { isPlainObject } from "./objects";

/**
 * Handles text that is in the ApplicationMessage form ({ id: string, message: string, properties: object })
 * @param text
 * @returns {string}
 */
export const retrieveText = (
  text:
    | string
    | { id?: string, message: string, properties?: { [key: string]: any } },
): string | null => {
  if (typeof text === "string") {
    return text;
  }

  if (isPlainObject(text) && "message" in text) {
    return text.message;
  }

  return null;
};
